import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    thresholdKm: { type: Number, default: 0.5 }
  }

  connect() {
    this.getLocationAndUpdateStores()
  }

  getLocationAndUpdateStores() {
    if (!navigator.geolocation) {
      this.fallbackToIP()
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        document.cookie = "location_allowed=true; max-age=31536000; path=/; Secure; SameSite=Lax"
        this.processLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        })
      },
      (error) => {
        console.warn("Geolocation failed:", error.message)
        this.fallbackToIP()
      }
    )
  }

  async fallbackToIP() {
    try {
      const res = await fetch("/location/ip", {
        headers: { Accept: "application/json" }
      })
      if (!res.ok) throw new Error("IP lookup failed")

      const data = await res.json()
      if (!data.latitude || !data.longitude) throw new Error("No coordinates from IP")

      this.processLocation({ latitude: data.latitude, longitude: data.longitude })
    } catch (err) {
      console.error("IP fallback failed:", err)
      // Sin fallback adicional — el server renderiza sin filtro de ubicación
    }
  }

  processLocation(currentLocation) {
    const storedCookie = document.cookie.split("; ").find(row => row.startsWith("last_location="))

    if (storedCookie) {
      const [lat, lon] = decodeURIComponent(storedCookie.split("=")[1]).split("&").map(Number)
      const storedLocation = { latitude: lat, longitude: lon }
      if (this.locationHasChanged(currentLocation, storedLocation)) {
        this.updateLocationAndStores(currentLocation)
      }
    } else {
      this.updateLocationAndStores(currentLocation)
    }
  }

  locationHasChanged(current, stored) {
    const toRad = deg => deg * Math.PI / 180
    const dLat = toRad(current.latitude - stored.latitude)
    const dLon = toRad(current.longitude - stored.longitude)
    const lat1 = toRad(stored.latitude)
    const lat2 = toRad(current.latitude)

    const a = Math.sin(dLat / 2) ** 2 +
              Math.sin(dLon / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const distance = 6371 * c

    return distance > this.thresholdKmValue
  }

  async updateLocationAndStores(location) {
    const lat = location.latitude
    const lon = location.longitude

    document.cookie = `last_location=${lat}&${lon}; path=/`

    const res = await fetch(`/stores?latitude=${lat}&longitude=${lon}`, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
    if (res.ok) Turbo.renderStreamMessage(await res.text())
  }
}